const modal = {
  filter: {
    title: 'Filter pharmacies',
    filterBy: 'Filter by',
    selectedFilters: 'Selected filters',
    clearFilters: 'Clear filter',
    onlinePayment: 'Online payment',
    servicesIcon: 'Services Icon',
    magazineIcon: 'Magazine icon',
  },
  login: {
    welcome: {
      0: 'Welcome',
      1: 'please',
      2: 'report',
      3: 'Look here',
      4: 'on.',
    },
    forgotPassword: 'Forgot your password?',
    new: 'New at DeineApotheken.de?',
    join: 'Register now',
    remember: 'Remember me',
  },
  logout: {
    title: 'Are you sure you want to log out?',
    description: 'If you log out, your shopping cart will be emptied and you will be redirected to the home page',
    confirm: 'Log out',
    cancel: 'No, stay logged in',
  },
  loggedOut: {
    close: 'Close',
    message: 'You have successfully logged out.',
  },
  maxAmount: {
    title: 'The maximum order quantity for the product has been reached for legal reasons.',
    close: 'Close',
  },
  coupon: {
    title: 'Coupon deactivation',
    description: 'Are you sure you want to remove the coupon?',
    confirm: 'Yes',
    cancel: 'No',
  },
  pharmacyInfo: {
    messengerServicePossible: 'Delivery service with appointment',
    onlinePayment: 'Online payment possible',
    changePharmacy: 'Change pharmacy',
    yourPharmacy: 'Your selected pharmacy',
    toWebsite: 'To the website',
    zipCodes: 'Delivery to zip code: {codes}',
    distanceLimit: 'Delivery within a radius of: {distance}',
    serviceIcon: 'Service icon',
    whatsAppDescription: 'Contact us directly via WhatsApp by scanning the QR code or clicking on the WhatsApp button to open the chat in the browser.',
  },
  cancelOrder: {
    title: 'Cancellation of Your Order',
    description: 'Please contact your pharmacy at the telephone number <strong>[PHARMACY_TELEPHONE_NUMBER]</strong> to cancel your order.',
    descriptionNoPhone: 'Please contact your pharmacy using the contact details listed above to cancel your order.',
  },
  emptyCart: {
    title: 'You currently have no products in your shopping cart.',
    description: 'Browse through our categories or simply search for a product of your choice using the search field.',
    confirmText: 'Discover Products',
  },
  epaper: {
    title: 'Cancel my life e-paper subscription',
    description: 'Do you really want to cancel your my life e-paper subscription? The magazine will then no longer be available to you digitally. Of course, you will continue to receive my life as a magazine from your local pharmacy as usual.',
    confirmText: 'Cancel subscription',
    cancelText: 'Cancel',
  },
  iaAppDownload: {
    title: 'Download the app now!',
    description: 'Order even more conveniently and use exclusive app functions such as reminders to take your medication.',
  },
  disabledCameraAccess: {
    title: 'Camera permission denied',
    description: 'Oops, looks like we can\'t access your camera. Please enable it in your browser settings or check if it is connected properly.',
    confirmText: 'Close',
  },
  emptySearch: {
    noTermDescription: 'Please enter a search term, a product name, a PZN or a category in the search field.',
    description: 'To start your search, please enter the first 3 characters of the medication or PZN number.',
  },
  advertisement: {
    title: 'Product advertisement',
    description: 'Products marked as "Advertisements" are paid advertisements. They are listed first. The order of the products displayed depends on the selected sorting option. Under "Popularity," ads are displayed based on relevance, taking into account the search terms entered. Sales data from the past few months is also taken into account to determine the displayed order. Under "Product Name," all search results for the entered search term are displayed in alphabetical order.',
  },
}

export default modal
